import React, { Component } from 'react';
import i18n from '../i18n';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { connect } from 'react-redux';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import EventReportsActions from '../redux/EventReportsRedux';
import SitesActions from '../redux/SitesRedux';
import PersonsActions from '../redux/PersonsRedux';
import { withStyles } from '@material-ui/styles';
import withWidth from '@material-ui/core/withWidth';
import clsx from 'clsx';
import { Colors, StyledComponents, Metrics, Images } from '../themes';
import cloneDeep from 'lodash/cloneDeep';
import Header from '../components/header/Header';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Table from '../components/common/Table';
import AlertDialog from '../components/common/AlertDialog';
import SnackbarNotification from '../components/common/SnackbarNotification';
import EventReportDetails from '../components/reportsElements/EventReportDetails';
import { datePresets as rawDatePresets, eventReportColumns as rawColumns } from '../config/AppConfig';
import subDays from 'date-fns/subDays';
import subWeeks from 'date-fns/subWeeks';
import subMonths from 'date-fns/subMonths';
import startOfDay from 'date-fns/startOfDay';
import endOfDay from 'date-fns/endOfDay';
import startOfWeek from 'date-fns/startOfWeek';
import endOfWeek from 'date-fns/endOfWeek';
import startOfMonth from 'date-fns/startOfMonth';
import endOfMonth from 'date-fns/endOfMonth';
import { hackToSubtractOffset, hackToAddOffset, formatDateTime, haveSameIds } from '../lib/Utils';
import { EVENT_REPORT_EXCEL_MAX_ROWS } from '../config/AppConfig';
import decode from 'jwt-decode';

const { MainContentContainer } = StyledComponents;

const styles = (theme) => ({
  gridContainer: {
    [theme.breakpoints.up('xl')]: {
      maxWidth: Metrics.contentGridMaxWidthXl.general,
    },
  },
  paper: {
    textAlign: 'center',
    background: Colors.hoverGrey,
    color: Colors.white,
  },
});

const allColumns = [{ columnId: 1 }, { columnId: 2 }, { columnId: 3 }, { columnId: 4 }, { columnId: 5 }];

class EventReports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // snackbar
      isSnackbarNotificationOpen: false,
      snackbarVariant: 'warning',
      snackbarMessage: '',
      // alert confirm dialog
      isAlertDialogOpen: false,
      alertTitle: '',
      alertContentText: '',
      alertConfirmButtonText: 'Global_delete',
      alertConfirmAction: null,
      showExcelReport: false,
      // reportModels page params
      reportModelsItemsPerPage: 10,
      reportModelsPageNumber: 0,
      reportModelsSearchValue: null,
      reportModelsSortDirection: 'ASC',
      // reportModels details
      hideDetails: true,
      isNewReportModel: false,
      reportModelId: null,
      name: '',
      description: '',
      userId: null,
      typeId: '',
      // date time
      dateSelection: '1',
      startTime: hackToAddOffset(startOfDay(new Date()).toJSON()),
      endTime: hackToAddOffset(endOfDay(new Date()).toJSON()),
      // form Errors:
      isUntouched: true,
      isExecuteButtonHovered: false,
      // filters
      checkedSites: [],
      isSelectAllSitesButtonChecked: true,
      checkedControllers: [],
      isSelectAllControllersButtonChecked: true,
      checkedPersons: [],
      isSelectAllPersonsButtonChecked: true,
      checkedColumns: allColumns,
      isSelectAllColumnsButtonChecked: true,
      isReportVisible: false,
      // event report pageParams:
      eventReportItemsPerPage: 10,
      eventReportPageNumber: 0,
      eventReportSearchValue: null,
      // eventReportSortBy: 'id',
      eventReportSortBy: 'time',
      eventReportSortDirection: 'DESC', // id should be DESC, all other parameters ASC
    };
  }

  componentDidMount() {
    if (this.props.customerId) {
      this.sendGetReportModelsRequest();
      this.sendGetAllSitesRequest();
      this.sendGetControllersRequest();
      this.sendGetPersonsRequest();
    }
  }

  componentWillUnmount() {
    this.props.resetSites();
    this.props.resetControllers();
    this.props.resetPersons();
  }

  componentDidUpdate(prevProps, prevState) {
    // As reportModels are user based, no need to reset reportModels if customer changes, only the data it uses
    if (prevProps.customerId !== this.props.customerId) {
      this.props.resetSites();
      this.props.resetControllers();
      this.props.resetPersons();
      this.resetReportModelFormFields();
      if (this.props.customerId) {
        this.sendGetReportModelsRequest();
        this.sendGetAllSitesRequest();
        this.sendGetControllersRequest();
        this.sendGetPersonsRequest();
      }
    }
    if (prevProps.isLoadingExcel && !this.props.isLoadingExcel && this.state.showExcelReport) {
      if (this.props.eventReportsErrorMessage) {
        this.setState({
          isSnackbarNotificationOpen: true,
          snackbarVariant: 'error',
          snackbarMessage: this.props.eventReportsErrorMessage,
          showExcelReport: false,
        });
      } else {
        this.exportToExcel();
        this.setState({ showExcelReport: false });
      }
    }
    if (prevProps.eventReportsIsLoading && !this.props.eventReportsIsLoading) {
      if (this.props.eventReportsSuccessMessage) {
        this.setState({
          isSnackbarNotificationOpen: true,
          snackbarVariant: 'success',
          snackbarMessage: this.props.eventReportsSuccessMessage,
        });
      }
      if (this.props.eventReportsErrorMessage) {
        this.setState({
          isSnackbarNotificationOpen: true,
          snackbarVariant: 'error',
          snackbarMessage: this.props.eventReportsErrorMessage,
        });
      }
      if (prevProps.createdId !== this.props.createdId) {
        this.setState({ reportModelId: this.props.createdId, isNewReportModel: false, isUntouched: true });
      }
    }
    // sites checkbox select all
    if (!prevState.isSelectAllSitesButtonChecked && this.state.isSelectAllSitesButtonChecked) {
      this.setState({ checkedSites: this.props.sites });
    }
    if (
      prevState.isSelectAllSitesButtonChecked &&
      !this.state.isSelectAllSitesButtonChecked &&
      haveSameIds(this.props.sites, this.state.checkedSites, 'sub')
    ) {
      this.setState({ checkedSites: [] });
    }
    if (prevState.checkedSites !== this.state.checkedSites) {
      this.setState({
        isSelectAllSitesButtonChecked: haveSameIds(this.props.sites, this.state.checkedSites, 'sub'),
      });
    }
    // controllers checkbox select all
    if (!prevState.isSelectAllControllersButtonChecked && this.state.isSelectAllControllersButtonChecked) {
      this.setState({ checkedControllers: this.props.controllers });
    }
    if (
      prevState.isSelectAllControllersButtonChecked &&
      !this.state.isSelectAllControllersButtonChecked &&
      haveSameIds(this.props.controllers, this.state.checkedControllers, 'sub')
    ) {
      this.setState({ checkedControllers: [] });
    }
    if (prevState.checkedControllers !== this.state.checkedControllers) {
      this.setState({
        isSelectAllControllersButtonChecked: haveSameIds(this.props.controllers, this.state.checkedControllers, 'sub'),
      });
    }
    // persons checkbox select all
    if (!prevState.isSelectAllPersonsButtonChecked && this.state.isSelectAllPersonsButtonChecked) {
      this.setState({ checkedPersons: this.props.persons });
    }
    if (
      prevState.isSelectAllPersonsButtonChecked &&
      !this.state.isSelectAllPersonsButtonChecked &&
      haveSameIds(this.props.persons, this.state.checkedPersons, 'sub')
    ) {
      this.setState({ checkedPersons: [] });
    }
    if (prevState.checkedPersons !== this.state.checkedPersons) {
      this.setState({
        isSelectAllPersonsButtonChecked: haveSameIds(this.props.persons, this.state.checkedPersons, 'sub'),
      });
    }
    // columns checkbox select all
    if (!prevState.isSelectAllColumnsButtonChecked && this.state.isSelectAllColumnsButtonChecked) {
      this.setState({ checkedColumns: allColumns });
    }
    if (
      prevState.isSelectAllColumnsButtonChecked &&
      !this.state.isSelectAllColumnsButtonChecked &&
      haveSameIds(allColumns, this.state.checkedColumns, 'columnId')
    ) {
      this.setState({ checkedColumns: [] });
    }
    if (prevState.checkedColumns !== this.state.checkedColumns) {
      this.setState({
        isSelectAllColumnsButtonChecked: haveSameIds(allColumns, this.state.checkedColumns, 'columnId'),
      });
    }
  }

  // send get filter data

  sendGetAllSitesRequest = () => {
    const pageParams = {
      items: -1,
      page: 0,
      value: null,
      sort: 'ASC',
    };
    this.props.getAllSites(this.props.customerId, pageParams);
  };

  sendGetControllersRequest = () => {
    const pageParams = {
      items: -1,
      page: 0,
      value: null,
      sort: 'ASC',
    };
    this.props.getCustomerControllers(this.props.customerId, pageParams);
  };

  sendGetPersonsRequest = () => {
    const pageParams = {
      items: -1,
      page: 0,
      value: null,
      sortBy: 'address.lastName',
      sortDirection: 'ASC',
    };
    this.props.getPersons(this.props.customerId, pageParams);
  };

  // reportModels list table methods

  sendGetReportModelsRequest = () => {
    const pageParams = {
      items: this.state.reportModelsItemsPerPage,
      page: this.state.reportModelsPageNumber,
      value: this.state.reportModelsSearchValue,
      sort: this.state.reportModelsSortDirection,
    };
    this.props.getReportModels(pageParams);
  };

  changeReportModelsItemsPerPage = (reportModelsItemsPerPage) => {
    this.setState({ reportModelsItemsPerPage, reportModelsPageNumber: 0 }, () => this.sendGetReportModelsRequest());
  };

  changeReportModelsPage = (reportModelsPageNumber) => {
    this.setState({ reportModelsPageNumber }, () => this.sendGetReportModelsRequest());
  };

  handleSearchReportModel = (reportModelsSearchValue) => {
    this.setState({ reportModelsSearchValue, reportModelsPageNumber: 0 }, () => this.sendGetReportModelsRequest());
    this.resetReportModelFormFields();
  };

  handleSortReportModel = (reportModelsSortBy, reportModelsSortDirection) => {
    this.setState({ reportModelsSortDirection, reportModelsPageNumber: 0 }, () => this.sendGetReportModelsRequest());
    this.resetReportModelFormFields();
  };

  handleSearchReportModelKeyPress = (event, value) => {
    if (event.key === 'Enter') {
      this.handleSearchReportModel(value);
    }
  };

  selectReportModel = ({
    reportModelId,
    name,
    description,
    userId,
    exceptionDateId,
    typeId,
    dateSelection,
    sites,
    controllers,
    persons,
    columns,
  }) => {
    const checkedSites = sites.reduce((newSites, site) => {
      const sub = decode(site).sub;
      const newSiteId = this.props.sites.find((site2) => site2.sub === sub)?.siteId;
      if (newSiteId) {
        const newSite = { sub, siteId: newSiteId };
        newSites.push(newSite);
      }
      return newSites;
    }, []);
    const checkedControllers = controllers.reduce((newControllers, controller) => {
      const sub = decode(controller).sub;
      const newControllerId = this.props.controllers.find((controller2) => controller2.sub === sub)?.controllerId;
      if (newControllerId) {
        const newController = { sub, controllerId: newControllerId };
        newControllers.push(newController);
      }
      return newControllers;
    }, []);
    const checkedPersons = persons.reduce((newPersons, person) => {
      const sub = decode(person).sub;
      const newPersonId = this.props.persons.find((person2) => person2.sub === sub)?.personId;
      if (newPersonId) {
        const newPerson = { sub, personId: newPersonId };
        newPersons.push(newPerson);
      }
      return newPersons;
    }, []);
    const checkedColumns = columns.map((id) => ({ columnId: parseInt(id) }));
    this.resetReportModelFormFields();
    this.setState({
      hideDetails: false,
      isNewReportModel: false,
      reportModelId,
      name,
      description,
      userId,
      exceptionDateId,
      typeId,
      dateSelection: dateSelection ? dateSelection : '1',
      checkedSites,
      isSelectAllSitesButtonChecked: haveSameIds(this.props.sites, checkedSites, 'sub'),
      checkedControllers,
      isSelectAllControllersButtonChecked: haveSameIds(this.props.controllers, checkedControllers, 'sub'),
      checkedPersons,
      isSelectAllPersonsButtonChecked: haveSameIds(this.props.persons, checkedPersons, 'sub'),
      checkedColumns,
      isSelectAllColumnsButtonChecked: haveSameIds(allColumns, checkedColumns, 'sub'),
    });
    this.selectDateRange(dateSelection);
  };

  // ReportModel details form methods

  resetReportModelFormFields = () => {
    this.setState({
      reportModelId: null,
      name: '',
      description: '',
      userId: null,
      typeId: 1,
      dateSelection: '1',
      startTime: hackToAddOffset(startOfDay(new Date()).toJSON()),
      endTime: hackToAddOffset(endOfDay(new Date()).toJSON()),
      checkedSites: this.props.sites,
      isSelectAllSitesButtonChecked: true,
      checkedControllers: this.props.controllers,
      isSelectAllControllersButtonChecked: true,
      checkedPersons: this.props.persons,
      isSelectAllPersonsButtonChecked: true,
      checkedColumns: allColumns,
      isUntouched: true,
      isExecuteButtonHovered: false,
    });
  };

  handleAddReportModel = () => {
    this.resetReportModelFormFields();
    this.setState({ hideDetails: false, reportModelsSearchValue: null, isNewReportModel: true });
  };

  handleChangeFormValues = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleReportModelDetailsFormKeyPress = (event) => {
    if (event.key === 'Enter') {
      if (!this.state.usersSearchValue) {
        return this.handleSaveReportModel();
      }
    }
  };

  handleSaveReportModel = () => {
    const {
      reportModelId,
      name,
      description,
      typeId,
      userId,
      dateSelection,
      checkedSites,
      checkedControllers,
      checkedPersons,
      checkedColumns,
    } = this.state;
    const sites = checkedSites.map(({ siteId }) => siteId);
    const controllers = checkedControllers.map(({ controllerId }) => controllerId);
    const persons = checkedPersons.map(({ personId }) => personId);
    const columns = checkedColumns.map(({ columnId }) => columnId.toString());
    const reportModelInfos = {
      name,
      description,
      typeId,
      userId,
      dateSelection,
      sites,
      controllers,
      persons,
      columns,
    };
    const editReportModelInfos = { ...reportModelInfos, reportModelId };
    const pageParams = {
      items: this.state.reportModelsItemsPerPage,
      page: this.state.reportModelsPageNumber,
      value: this.state.reportModelsSearchValue,
      sort: this.state.reportModelsSortDirection,
    };
    this.state.isNewReportModel
      ? this.props.createReportModel(reportModelInfos, pageParams)
      : this.props.editReportModel(editReportModelInfos, pageParams);
  };

  openDeleteReportModelAlert = () => {
    const modelName = this.state.name;
    this.setState({
      isAlertDialogOpen: true,
      alertTitle: i18n.t('alert.deleteReportModelTitle'),
      alertContentText: i18n.t('reportManager_EventReport_confirm', { modelName }),
      alertConfirmButtonText: 'Global_delete',
      alertConfirmAction: this.deleteReportModel,
    });
  };

  deleteReportModel = () => {
    const pageParams = {
      items: this.state.reportModelsItemsPerPage,
      page: this.state.reportModelsPageNumber,
      value: this.state.reportModelsSearchValue,
      sort: this.state.reportModelsSortDirection,
    };
    this.props.deleteReportModel(this.state.reportModelId, pageParams);
    this.resetReportModelFormFields();
    this.setState({ isAlertDialogOpen: false, hideDetails: true });
  };

  selectDateRange = (dateSelection) => {
    const now = new Date();
    let startTime, endTime;
    switch (dateSelection) {
      case '1': //today
        startTime = startOfDay(now);
        endTime = endOfDay(now);
        break;
      case '2': //last24h
        startTime = subDays(now, 1);
        endTime = now;
        break;
      case '3': //yesterday
        startTime = startOfDay(subDays(now, 1));
        endTime = endOfDay(subDays(now, 1));
        break;
      case '4': //current week
        startTime = startOfWeek(now, { weekStartsOn: 1 });
        endTime = endOfWeek(now, { weekStartsOn: 1 });
        break;
      case '5': //last week
        startTime = startOfWeek(subWeeks(now, 1), { weekStartsOn: 1 });
        endTime = endOfWeek(subWeeks(now, 1), { weekStartsOn: 1 });
        break;
      case '6': //current month
        startTime = startOfMonth(now);
        endTime = endOfMonth(now);
        break;
      case '7': //last month
        startTime = startOfMonth(subMonths(now, 1));
        endTime = endOfMonth(subMonths(now, 1));
        break;
      default:
        //1, today
        startTime = startOfDay(now);
        endTime = endOfDay(now);
    }
    const convert = (date) => hackToAddOffset(date.toJSON());
    this.setState({ dateSelection, startTime: convert(startTime), endTime: convert(endTime) });
  };

  // execute report & eventReport list table methods

  executeReport = () => {
    this.setState({ isReportVisible: true });
    this.sendGetEventReportRequest();
  };

  sendGetEventReportRequest = () => {
    const {
      checkedSites,
      checkedControllers,
      checkedPersons,
      isSelectAllSitesButtonChecked,
      isSelectAllControllersButtonChecked,
      isSelectAllPersonsButtonChecked,
    } = this.state;
    const filters = {
      ...(!isSelectAllSitesButtonChecked &&
        checkedSites.length > 0 && { sites: checkedSites.map(({ siteId }) => siteId) }),
      ...(!isSelectAllControllersButtonChecked &&
        checkedControllers.length > 0 && {
          controllers: checkedControllers.map(({ controllerId }) => controllerId),
        }),
      ...(!isSelectAllPersonsButtonChecked &&
        checkedPersons.length > 0 && { persons: checkedPersons.map(({ personId }) => personId) }),
    };
    let sortBy;
    switch (this.state.eventReportSortBy) {
      case 'time':
        sortBy = 'eventLogId';
        break;
      case 'event':
        sortBy = 'controllerMessageValue';
        break;
      case 'site':
        sortBy = 'siteOrgName';
        break;
      case 'controller':
        sortBy = 'controllerName';
        break;
      case 'tag':
        sortBy = 'tagUid';
        break;
      case 'person':
        sortBy = 'personOrgName';
        break;
      case 'controllerUid':
        sortBy = 'controllerUid';
        break;
      case 'controllerReaderDirection':
        sortBy = 'controllerReaderDirection';
        break;
      default:
        sortBy = 'eventLogId';
    }
    const params = {
      startTime: this.state.startTime ? this.state.startTime.slice(0, -5) : null,
      endTime: this.state.endTime ? this.state.endTime.slice(0, -5) : null,
      items: this.state.eventReportItemsPerPage,
      page: this.state.eventReportPageNumber,
      value: this.state.eventReportSearchValue,
      sortBy,
      sortDirection: this.state.eventReportSortDirection,
    };
    this.props.getEventReport(this.props.customerId, filters, params);
  };

  changeEventReportItemsPerPage = (eventReportItemsPerPage) => {
    this.setState({ eventReportItemsPerPage, eventReportPageNumber: 0 }, () => this.sendGetEventReportRequest());
  };

  changeEventReportPage = (eventReportPageNumber) => {
    this.setState({ eventReportPageNumber }, () => this.sendGetEventReportRequest());
  };

  handleSearchEventReport = (eventReportSearchValue) => {
    this.setState({ eventReportSearchValue, eventReportPageNumber: 0 }, () => this.sendGetEventReportRequest());
  };

  handleSortEventReport = (eventReportSortBy, eventReportSortDirection) => {
    this.setState({ eventReportSortBy, eventReportSortDirection, eventReportPageNumber: 0 }, () =>
      this.sendGetEventReportRequest()
    );
  };

  handleSearchEventReportKeyPress = (event, value) => {
    if (event.key === 'Enter') {
      this.handleSearchEventReport(value);
    }
  };

  getExcelReport = () => {
    const { checkedSites, checkedControllers, checkedPersons } = this.state;
    const { eventReportTotalElements } = this.props;
    const filters = {
      sites: checkedSites.map(({ siteId }) => siteId),
      controllers: checkedControllers.map(({ controllerId }) => controllerId),
      persons: checkedPersons.map(({ personId }) => personId),
    };
    const params = {
      startTime: this.state.startTime ? this.state.startTime.slice(0, -5) : null,
      endTime: this.state.endTime ? this.state.endTime.slice(0, -5) : null,
      items: EVENT_REPORT_EXCEL_MAX_ROWS,
      page: 0,
      sortBy: 'eventLogId',
      sortDirection: 'DESC',
    };
    if (eventReportTotalElements > EVENT_REPORT_EXCEL_MAX_ROWS) {
      this.setState({
        isAlertDialogOpen: true,
        alertTitle: i18n.t('alert.exportExcelReportSubsetTitle'),
        alertContentText: i18n.t('alert.exportExcelReportSubsetContent', {
          maxRows: EVENT_REPORT_EXCEL_MAX_ROWS,
          totalElements: eventReportTotalElements,
        }),
        alertConfirmAction: () => {
          this.setState({ showExcelReport: true }, () =>
            this.props.getEventReportForExcel(this.props.customerId, filters, params)
          );
        },
        alertConfirmButtonText: 'Global_export',
      });
    } else {
      this.setState({ showExcelReport: true }, () =>
        this.props.getEventReportForExcel(this.props.customerId, filters, params)
      );
    }
  };

  exportToExcel = () => {
    const rawReportData = cloneDeep(this.props.eventReportForExcel);
    const reportData = rawReportData.map((row) => {
      return {
        ...row,
        time: formatDateTime(hackToSubtractOffset(row.time)),
      };
    });
    const fileName = 'digiovi-report';
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const ws = XLSX.utils.json_to_sheet(reportData);
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  render() {
    const { t, classes, width } = this.props;
    const isLarge = width === 'lg' || width === 'xl';
    const reportModelsData = cloneDeep(this.props.reportModels);
    const rawReportData = cloneDeep(this.props.eventReport);
    const reportData = rawReportData.map((row) => {
      return {
        ...row,
        time: formatDateTime(hackToSubtractOffset(row.time)),
        person: row.person?.replaceAll('null', ''), //TODO remove once backend fixed (ticket #678 )
      };
    });
    const hasWarningsOrErrors =
      reportData.findIndex(
        ({ controllerMessageType }) =>
          controllerMessageType === 'warning' ||
          controllerMessageType === 'error' ||
          controllerMessageType === 'success'
      ) > -1;
    const rawSitesData = cloneDeep(this.props.sites);
    const sitesData = rawSitesData
      ? rawSitesData.map((site) => ({
          ...site,
          name: site.address.fullName,
        }))
      : null;
    const controllersData = cloneDeep(this.props.controllers);
    const rawPersonsData = cloneDeep(this.props.persons);
    const personsData = rawPersonsData
      ? rawPersonsData.map((person) => ({
          ...person,
          name: person.address.fullName,
        }))
      : null;
    const datePresets = rawDatePresets.map((preset) => ({
      ...preset,
      translation: t(`Global_${preset.name}`),
    }));
    const columnsData = rawColumns.map((column) => ({
      ...column,
      translation: t(column.translation),
    }));
    const reportColumns = rawColumns
      .filter(
        (column) =>
          this.state.checkedColumns.findIndex((checkedColumn) => checkedColumn.columnId === column.columnId) >= 0
      )
      .map(({ name, translation }) => ({
        title: t(translation),
        field: name,
        id: name,
      }));

    return (
      <MainContentContainer className={classes.MainContentContainer}>
        <AlertDialog
          open={this.state.isAlertDialogOpen}
          handleClose={() => this.setState({ isAlertDialogOpen: false })}
          title={this.state.alertTitle}
          contentText={this.state.alertContentText}
          cancelButtonText={t('Global_cancel')}
          confirmButtonText={t(this.state.alertConfirmButtonText)}
          onConfirm={this.state.alertConfirmAction}
        />
        <SnackbarNotification
          variant={this.state.snackbarVariant}
          open={this.state.isSnackbarNotificationOpen}
          message={this.state.snackbarMessage}
          close={() => this.setState({ isSnackbarNotificationOpen: false })}
        />
        <Header />
        <Grid container className={classes.gridContainer} spacing={isLarge ? 6 : 5}>
          <Grid item xs={12} md={6} xl={5}>
            <Paper className={clsx(classes.paper, classes.listWidget)}>
              <Table
                data={reportModelsData}
                noDataText={t('reportManager_EventReport_models_noData')}
                handleClick={(value) => this.selectReportModel(value)}
                columns={[{ title: t('reportManager_EventReport_modelsCol1'), field: 'name', id: 'name' }]}
                activeRowValue={this.state.reportModelId}
                activeRowField={'reportModelId'}
                handleSearch={this.handleSearchReportModel}
                sortBy={'name'}
                sortDirection={this.state.reportModelsSortDirection}
                handleSort={this.handleSortReportModel}
                searchPlaceholder={t('reportManager_EventReport_search_report_model')}
                itemsPerPage={this.state.reportModelsItemsPerPage}
                changeItemsPerPage={this.changeReportModelsItemsPerPage}
                totalElements={this.props.reportModelsTotalElements}
                page={this.state.reportModelsPageNumber}
                changePage={this.changeReportModelsPage}
                onKeyPress={this.handleSearchReportModelKeyPress}
                // rows per page select props
                selectData={[5, 10, 20]}
                selectLabel={t('table.showPerPage')}
                selectValue={this.state.reportModelsItemsPerPage}
                onSelect={this.changeReportModelsItemsPerPage}
                selectWidth={90}
              />
            </Paper>
          </Grid>
          <Grid item xs={12} md={6} xl={7}>
            <Paper className={clsx(classes.paper, classes.detailsWidget)}>
              <EventReportDetails
                // buttons
                add1ButtonText={t('reportManager_addReportModel')}
                add2ButtonText={t('reportManager_excecuteReport')}
                onDeleteButtonClick={this.openDeleteReportModelAlert}
                onAdd1ButtonClick={this.handleAddReportModel}
                onAdd2ButtonClick={this.executeReport}
                onSaveButtonClick={this.handleSaveReportModel}
                isDeleteButtonDisabled={!this.state.reportModelId || this.state.isNewReportModel}
                // details form
                onChange={this.handleChangeFormValues}
                hideDetails={this.state.hideDetails}
                reportModelId={this.state.reportModelId}
                name={this.state.name}
                description={this.state.description}
                // date preset select
                datePresetSelectData={datePresets}
                datePresetSelectLabel={t('reportManager_modelInfo_dateSelection')}
                datePresetAccessValue={'id'}
                datePresetAccessLabel={'translation'}
                datePresetSelectValue={this.state.dateSelection}
                datePresetOnSelect={(dateSelection) => this.selectDateRange(dateSelection)}
                // datetime pickers
                startTime={this.state.startTime}
                handleStartDateChange={(time) =>
                  this.setState({ startTime: time ? hackToAddOffset(time.toJSON()) : null })
                }
                endTime={this.state.endTime}
                handleEndDateChange={(time) => this.setState({ endTime: time ? hackToAddOffset(time.toJSON()) : null })}
                // form and validations
                isUntouched={this.state.isUntouched}
                setUntouched={(value) => this.setState({ isUntouched: value })}
                // report validation on hovering execute button
                isExecuteButtonHovered={this.state.isExecuteButtonHovered}
                setExecuteButtonHovered={(boolean) => this.setState({ isExecuteButtonHovered: boolean })}
                // filter tables
                changeCheckedValues={(newChecked, checkedField) => this.setState({ [checkedField]: newChecked })}
                sites={sitesData}
                checkedSites={this.state.checkedSites}
                isSelectAllSitesButtonChecked={this.state.isSelectAllSitesButtonChecked}
                changeSelectAllSitesButton={() =>
                  this.setState((prevState) => ({
                    isSelectAllSitesButtonChecked: !prevState.isSelectAllSitesButtonChecked,
                  }))
                }
                controllers={controllersData}
                checkedControllers={this.state.checkedControllers}
                isSelectAllControllersButtonChecked={this.state.isSelectAllControllersButtonChecked}
                changeSelectAllControllersButton={() =>
                  this.setState((prevState) => ({
                    isSelectAllControllersButtonChecked: !prevState.isSelectAllControllersButtonChecked,
                  }))
                }
                persons={personsData}
                checkedPersons={this.state.checkedPersons}
                isSelectAllPersonsButtonChecked={this.state.isSelectAllPersonsButtonChecked}
                changeSelectAllPersonsButton={() =>
                  this.setState((prevState) => ({
                    isSelectAllPersonsButtonChecked: !prevState.isSelectAllPersonsButtonChecked,
                  }))
                }
                columns={columnsData}
                checkedColumns={this.state.checkedColumns}
                isSelectAllColumnsButtonChecked={this.state.isSelectAllColumnsButtonChecked}
                changeSelectAllColumnsButton={() =>
                  this.setState((prevState) => ({
                    isSelectAllColumnsButtonChecked: !prevState.isSelectAllColumnsButtonChecked,
                  }))
                }
              />
            </Paper>
          </Grid>
          {this.state.isReportVisible && (
            <Grid item xs={12}>
              <Paper className={clsx(classes.paper, classes.reportWidget)}>
                <Table
                  data={reportData}
                  noDataText={t('Global_noData')}
                  // handleClick={(value) => this.selectReportModel(value)}
                  columns={reportColumns}
                  hasWarningsOrErrors={hasWarningsOrErrors}
                  colorRowField={'controllerMessageType'}
                  successCondition={'success'}
                  warningCondition={'warning'}
                  errorCondition={'error'}
                  handleSearch={this.handleSearchEventReport}
                  sortBy={this.state.eventReportSortBy}
                  sortDirection={this.state.eventReportSortDirection}
                  handleSort={this.handleSortEventReport}
                  searchPlaceholder={t('ReportManager_getEventReport_search')}
                  itemsPerPage={this.state.eventReportItemsPerPage}
                  changeItemsPerPage={this.changeEventReportItemsPerPage}
                  totalElements={this.props.eventReportTotalElements}
                  page={this.state.eventReportPageNumber}
                  changePage={this.changeEventReportPage}
                  onKeyPress={this.handleSearchEventReportKeyPress}
                  // header Middle button for Excel export
                  headerMiddleButtonText={t('table.exportToExcel')}
                  headerMiddleButtonIcon={Images.excel}
                  headerMiddleButtonAction={this.getExcelReport}
                  // rows per page select props
                  selectData={[5, 10, 20]}
                  selectLabel={t('table.showPerPage')}
                  selectValue={this.state.eventReportItemsPerPage}
                  onSelect={this.changeEventReportItemsPerPage}
                  selectWidth={90}
                  copyable
                />
              </Paper>
            </Grid>
          )}
        </Grid>
      </MainContentContainer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    customerId: state.auth.customerId,
    //reportModels
    reportModels: state.eventReports.reportModels,
    reportModelsTotalElements: state.eventReports.reportModelsTotalElements,
    createdId: state.eventReports.createdId,
    eventReportsIsLoading: state.eventReports.isLoading,
    eventReportsSuccessMessage: state.eventReports.successMessage,
    eventReportsErrorMessage: state.eventReports.errorMessage,
    eventReport: state.eventReports.eventReport,
    eventReportTotalElements: state.eventReports.eventReportTotalElements,
    eventReportForExcel: state.eventReports.eventReportForExcel,
    isLoadingExcel: state.eventReports.isLoadingExcel,
    // filters
    sites: state.sites.allSites,
    sitesIsLoading: state.sites.isLoading,
    controllers: state.sites.customerControllers,
    controllersIsLoading: state.sites.controllersIsLoading,
    persons: state.persons.persons,
    personsIsLoading: state.persons.isLoading,
  };
};

const mapDispatchToProps = (dispatch) => ({
  // reportModels
  getReportModels: (pageParams) => dispatch(EventReportsActions.getReportModelsRequest(pageParams)),
  createReportModel: (reportModelInfos, pageParams) =>
    dispatch(EventReportsActions.createReportModelRequest(reportModelInfos, pageParams)),
  editReportModel: (reportModelInfos, pageParams) =>
    dispatch(EventReportsActions.editReportModelRequest(reportModelInfos, pageParams)),
  deleteReportModel: (reportModelId, pageParams) =>
    dispatch(EventReportsActions.deleteReportModelRequest(reportModelId, pageParams)),
  getEventReport: (customerId, filters, params) =>
    dispatch(EventReportsActions.getEventReportRequest(customerId, filters, params)),
  getEventReportForExcel: (customerId, filters, params) =>
    dispatch(EventReportsActions.getEventReportForExcel(customerId, filters, params)),

  // filter data
  getAllSites: (customerId, pageParams) => dispatch(SitesActions.getAllSitesRequest(customerId, pageParams)),
  getCustomerControllers: (customerId, pageParams) =>
    dispatch(SitesActions.getCustomerControllersRequest(customerId, pageParams)),
  getPersons: (customerId, pageParams) => dispatch(PersonsActions.getPersonsRequest(customerId, pageParams)),
  resetSites: () => dispatch(SitesActions.resetSites()),
  resetControllers: () => dispatch(SitesActions.resetControllers()),
  resetPersons: () => dispatch(PersonsActions.resetPersons()),
});

export default compose(
  withTranslation(),
  withStyles(styles),
  withWidth(),
  connect(mapStateToProps, mapDispatchToProps)
)(EventReports);
